export const HEADER_HEIGHT = {
  MOBILE: 60,
  default: 60,
};

export const SIDENAV_BREAKPOINT = 960;
